import {
    getPersistedExperimentBucket,
    persistExperimentBucket,
    resolveExperimentBucket,
} from './abExperiment';
import { getPersistedValue, setPersistedValue } from './utils';

export const MARKETPLACE_EXPERIMENT_ID = 'marketplace_v1';
export const MARKETPLACE_COHORT_SETTING_KEY = 'cohort_marketplace_v1';
export const MARKETPLACE_EXPERIMENT_SETTING_KEY = 'cohort_marketplace_v1_experiment';
export const MARKETPLACE_BUCKETS = ['A', 'B'];
const DEFAULT_MARKETPLACE_B_PERCENTAGE = 10;

export const getMarketplaceBucketWeights = (value = process.env.REACT_APP_MARKETPLACE_B_PERCENTAGE) => {
    const percentage = Number(value);
    const marketplaceBPercentage = typeof value === 'string'
        && value.trim() !== ''
        && Number.isFinite(percentage)
        && percentage >= 0
        && percentage <= 100
        ? percentage
        : DEFAULT_MARKETPLACE_B_PERCENTAGE;

    return {
        A: 100 - marketplaceBPercentage,
        B: marketplaceBPercentage,
    };
};
export const MARKETPLACE_BUCKET_WEIGHTS = getMarketplaceBucketWeights();
export const MARKETPLACE_DEBUG_OVERRIDE_KEY = 'cr_debug_marketplace_v1_bucket';

const isDebugEnvironment = () => {
    const hostname = window.location.hostname || '';
    return hostname === 'localhost'
        || hostname === '127.0.0.1'
        || hostname.endsWith('.localhost')
        || hostname.includes('user-qa')
        || hostname.includes('staging');
};

export const isMarketplaceCohort = (value) => {
    return MARKETPLACE_BUCKETS.includes(typeof value === 'string' ? value.trim().toUpperCase() : '');
};

export const isMarketplaceExperimentFlag = (value) => {
    return value === '1' || value === 1 || value === true || value === 'true';
};

export const getMarketplaceCohort = () => {
    return getPersistedExperimentBucket({
        experimentId: MARKETPLACE_EXPERIMENT_ID,
        buckets: MARKETPLACE_BUCKETS,
    });
};

export const setMarketplaceCohort = (cohort) => {
    return persistExperimentBucket({
        experimentId: MARKETPLACE_EXPERIMENT_ID,
        bucket: cohort,
        buckets: MARKETPLACE_BUCKETS,
    });
};

export const getMarketplaceDebugCohort = () => {
    if (!isDebugEnvironment()) {
        return null;
    }

    const value = getPersistedValue(MARKETPLACE_DEBUG_OVERRIDE_KEY, MARKETPLACE_DEBUG_OVERRIDE_KEY);
    return isMarketplaceCohort(value) ? value.trim().toUpperCase() : null;
};

export const setMarketplaceDebugCohort = (cohort) => {
    const normalizedCohort = setMarketplaceCohort(cohort);
    if (normalizedCohort && isDebugEnvironment()) {
        setPersistedValue(MARKETPLACE_DEBUG_OVERRIDE_KEY, MARKETPLACE_DEBUG_OVERRIDE_KEY, normalizedCohort);
    }
    return normalizedCohort;
};

export const resolveMarketplaceCohort = ({ userSettings } = {}) => {
    const debugOverride = getMarketplaceDebugCohort();
    return resolveExperimentBucket({
        experimentId: MARKETPLACE_EXPERIMENT_ID,
        userBucket: debugOverride || userSettings?.[MARKETPLACE_COHORT_SETTING_KEY],
        buckets: MARKETPLACE_BUCKETS,
        bucketWeights: MARKETPLACE_BUCKET_WEIGHTS,
    });
};

export const getMarketplaceHeaderRoot = () => {
    if (typeof document === 'undefined') {
        return null;
    }

    return document.getElementById('header-root');
};

export const publishMarketplaceCartEnabled = (enabled) => {
    const headerRoot = getMarketplaceHeaderRoot();
    if (!headerRoot) {
        return;
    }

    if (enabled === true) {
        headerRoot.dataset.marketplaceCartEnabled = '1';
        return;
    }

    if (enabled === false) {
        headerRoot.dataset.marketplaceCartEnabled = '0';
        return;
    }

    delete headerRoot.dataset.marketplaceCartEnabled;
};
